import type { ReactNode } from 'react';

export const symbol_comedy_mask: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M578-320q42-35 53-89 2-8-3.5-13.5T614-428H345q-8 0-13 5.5t-3 13.5q11 54 53 89t98 35q56 0 98-35ZM480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-439v-381q0-25 17.5-42.5T180-880h600q25 0 42.5 17.5T840-820v381q0 74-28.5 139.5t-77 114q-48.5 48.5-114 77T480-80Zm0-60q125 0 212.5-87T780-439v-381H180v381q0 125 87.5 212T480-140Zm0-340ZM312-659q-19 15-25 38-2 7 3 12.5t13 5.5h106q8 0 13-5.5t3-12.5q-6-23-25-38t-44-15q-25 0-44 15Zm247.5 0Q540-644 534-621q-2 7 3 12.5t13 5.5h107q8 0 13-5.5t3-12.5q-6-23-25-38t-44-15q-25 0-44.5 15Z"
		/>
	</svg>
);
